<template>
    <div class="book-room-container">

        <vue-element-loading :active="isRequest" :is-full-screen="true" spinner="bar-fade-scale" color="#FF6700" />

        <div style="padding: 10px">
            <div class="filter-container">
                <span @click="filterClick1(type)" v-for="type in filter1" :class="{filterClick:type.flmc === type1 }">{{type.flmc}}</span>
            </div>
            <div class="filter-container">
                <span @click="filterClick2(type)" v-for="type in filter2" :class="{filterClick:type.split('_')[0] === type2 }">{{type.split('_')[0] }}</span>
            </div>
            <div class="filter-container">
                <span @click="filterClick3(type)" v-for="type in filter3" :class="{filterClick:type.split('_')[0] === type3 }">{{type.split('_')[0] }}</span>
            </div>
            <div class="filter-container">
                <span @click="filterClick4(type)" v-for="type in filter4" :class="{filterClick:type.split('_')[0] === type4 }">{{type.split('_')[0] }}</span>
            </div>
        </div>

        <div style="width: 100%;height: 1px;background-color: lightgray"></div>

        <div class="bookListContainer">
            <ul>
                <li v-for="book in bookList">
                    <div @click="getBookDetail(book.id)">
                        <img :src="book.pic1" alt="">
                        <span style="color: black;top: 10%;font-weight: bold">{{book.title}}</span>
                        <span style="top: 25%;color: #999999">作者：{{book.author}}</span>
                        <span style="top: 40%;color: #333333" class="book-dis">{{book.content}}</span>
                    </div>
                </li>
            </ul>

            <div @click="loadMore" class="more-style" v-if="showLoadMore">
                <span>更多</span>
            </div>

        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "BookRoomVue",
    data() {
        return {
            filter1: [],
            filter2: [
                "全部_all",
                "5萬字以上_5",
                "25萬字以上_25",
                "50萬字以上_50",
                "100萬字以上_100",
            ],
            filter3: [
                "全部_all",
                "限時免費_limitFree",
                "精品短片_shortChosen",
                "精品長片_longChosen",
            ],
            filter4: [
                "全部_all",
                "完本_finished",
                "連載_unfinished",
                "3天內有更新_recentUpdate",
            ],
            type1: "總裁",
            type2: "全部",
            type3: "全部",
            type4: "全部",
            param1: "",
            param2: "",
            param3: "",
            param4: "",
            bookList: [],
            page: 1,
            allPage: 0,
            isRequest: false,
            isLoadMore: false,
            showLoadMore: true,
        };
    },
    methods: {
        //第壹個類型點擊
        filterClick1: function (type) {
            this.page = 1;
            this.isLoadMore = false;
            this.type1 = type.flmc;
            this.param1 = type.id;
            this.getBookList();
        },

        //第二個類型點擊
        filterClick2: function (type) {
            this.page = 1;
            this.isLoadMore = false;
            this.type2 = type.split("_")[0];
            this.param2 = type.split("_")[1];
            this.getBookList();
        },

        //第三個類型點擊
        filterClick3: function (type) {
            this.page = 1;
            this.isLoadMore = false;
            this.type3 = type.split("_")[0];
            this.param3 = type.split("_")[1];
            this.getBookList();
        },

        //第四個類型點擊
        filterClick4: function (type) {
            this.page = 1;
            this.isLoadMore = false;
            this.type4 = type.split("_")[0];
            this.param4 = type.split("_")[1];
            this.getBookList();
        },

        //獲取所有的類型
        getAllType: function f() {
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getIndexLibraryType");
            this.$http.post(axios.baseURL, params).then((res) => {
                if (res.data.status) {
                    this.filter1 = res.data.data;
                }
            });
        },

        //獲取書籍列表
        getBookList: function () {
            this.isRequest = true;
            const params = new URLSearchParams();
            params.append("language", "zh-Hant");
            params.append("dev", "h5");
            params.append("uuid", "123456");
            params.append("ver", "1.0");
            params.append("ac", "getIndexLibrary");
            params.append("page", this.page);
            params.append("filter1", this.param1);
            params.append("filter2", this.param2);
            params.append("filter3", this.param3);
            params.append("filter4", this.param4);
            this.$http.post(axios.baseURL, params).then((res) => {
                this.isRequest = false;
                if (res.data.status) {
                    this.allPage = res.data.pages;
                    this.showLoadMore = this.page < this.allPage;
                    if (this.isLoadMore) {
                        let list = res.data.data;
                        for (let i = 0; i < list.length; i++) {
                            this.bookList.push(list[i]);
                        }
                    } else {
                        this.bookList = res.data.data;
                    }
                } else {
                    alert(res.data.msg);
                    this.showLoadMore = false;
                }
            });
        },

        //加載更多
        loadMore: function () {
            this.isLoadMore = true;
            this.page++;
            this.getBookList();
        },

        //獲取書籍詳情
        getBookDetail: function (bookId) {
            this.$router.push({
                path: "BookDetailVue",
                query: {
                    bookId: bookId,
                    vueName: "BookRoomVue",
                },
            });
        },
    },
    created() {
        this.getAllType();
        this.getBookList();
    },
};
</script>

<style scoped>
.book-room-container {
    margin-top: 50px;
}

.filter-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
}

.filter-container span {
    margin-left: 10px;
    font-size: 14px;
    margin-bottom: 10px;
}

.filterClick {
    background-color: lightgray;
    color: #ea477b;
    padding: 3px 10px;
    border: 1px solid gray;
    border-radius: 5px;
}

.bookListContainer {
    padding-bottom: 50px;
    overflow-x: hidden;
}

.bookListContainer ul {
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    text-align: left;
}

.bookListContainer ul li {
    list-style: none;
    border-bottom: 1px solid gainsboro;
    position: relative;
    padding: 10px;
}

.bookListContainer ul li img {
    width: 20%;
}

.bookListContainer ul li span {
    width: 70%;
    position: absolute;
    margin-left: 22%;
    font-size: 14px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
}

.book-dis {
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    line-clamp: 3;
    line-height: 20px;
    height: 60px;
    white-space: normal;
}

.more-style {
    height: 40px;
}

.more-style span {
    line-height: 40px;
}

.more-style:active {
    background-color: lightgrey;
}
</style>



// WEBPACK FOOTER //
// src/components/BookRoomVue.vue